import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth'
import { auth } from '../lib/firebase'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { ExclamationCircleIcon } from '@heroicons/react/24/outline'
import { FcGoogle } from 'react-icons/fc'
import { motion } from 'framer-motion'
import logo from '../assets/logo.png'; // Assuming logo.png is in src/assets

export default function Login() {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  const handleGoogleSignIn = async () => {
    try {
      setError(null);
      const provider = new GoogleAuthProvider()
      const result = await signInWithPopup(auth, provider)
      console.log('Sign in successful:', result.user.email);
      navigate('/dashboard');
    } catch (error) {
      console.error('Detailed error:', error);
      
      // Check for specific error types and set appropriate error message
      if (error.code === 'auth/unauthorized-domain') {
        setError('Authentication domain not authorized. Please contact support.');
      } else if (error.code === 'auth/popup-blocked') {
        setError('Popup was blocked by the browser. Please allow popups for this site.');
      } else if (error.code === 'auth/cancelled-popup-request') {
        setError('Sign in was cancelled. Please try again.');
      } else {
        setError('Failed to sign in. Please try again.');
      }
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-primary-100 to-secondary-100 dark:from-gray-800 dark:to-gray-900 transition-colors duration-200">
      <motion.div 
         initial={{ opacity: 0, y: 20 }}
         animate={{ opacity: 1, y: 0 }}
         className="card max-w-md w-full space-y-6 bg-white dark:bg-gray-700 shadow-xl"
      >
        <div>
          <img 
            className="mx-auto h-70 w-60"
            src={logo}
            alt="LearnSync Logo"
          />
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900 dark:text-white">
            Sign in to LearnSync
          </h2>
        </div>
        
        {error && (
          <div className="bg-red-100 dark:bg-red-900 border border-red-200 dark:border-red-800 text-red-800 dark:text-red-200 rounded-md p-4">
            <div className="flex items-center">
              <div className="flex-shrink-0">
                <ExclamationCircleIcon className="h-5 w-5 text-red-500 dark:text-red-300" aria-hidden="true" />
              </div>
              <div className="ml-3 flex-1">
                <p className="text-sm font-medium">
                  {error}
                </p>
              </div>
            </div>
          </div>
        )}

        <button
          onClick={handleGoogleSignIn}
          className="btn-primary group relative w-full flex justify-center items-center text-lg"
        >
          <span className="absolute left-0 inset-y-0 flex items-center pl-3">
            <FcGoogle className="h-6 w-6" />
          </span>
          Sign in with Google
        </button>
        {/* Potentially add a link to a Sign Up page here in the future */}
        {/* <div className="text-center text-sm text-gray-600 dark:text-gray-400 mt-4">
            Don't have an account? <Link to="/signup" className="text-primary-600 dark:text-primary-400 hover:underline">Sign Up</Link>
        </div> */}
      </motion.div>
    </div>
  )
} 